import React from 'react';
import useStyles from '../styles';

interface TypingAnimationProps {
  className?: string;
}

const TypingAnimation: React.FC<TypingAnimationProps> = ({ className }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.typingContainer} ${className ?? ''}`}>
      <div className={classes.typingDot} />
      <div className={classes.typingDot} />
      <div className={classes.typingDot} />
    </div>
  );
};

export default TypingAnimation;
